<script setup lang="ts">
import { url } from 'lib/url'
import { isRelativeUrl } from 'lib/routing'
import type { NavItemSchema } from 'types/storyblok/nav-item'

interface Props {
  story: NavItemSchema
  position?: number
}

const props = withDefaults(defineProps<Props>(), {
  position: -1,
})

const storefrontStore = useStorefrontStore()
const { current: currentStorefront } = storefrontStore

const type = computed(() => {
  return props.story?.linkType || props.story?.linktype
})

const slug = computed(() => {
  if (type.value === 'internal')
    return props.story?.slug?.replace(`${currentStorefront.storefrontCode}/`, '')
  else if (type.value === 'story')
    return props.story?.cached_url?.replace(`${currentStorefront.storefrontCode}/`, '')
  else if (type.value === 'url')
    return props.story.url

  return ''
})

const rel = computed(() => {
  if (typeof props.story.noFollow !== 'undefined' && props.story.noFollow === 'true')
    return 'nofollow noopener'
  else
    return 'noreferrer noopener'
})

const target = computed(() => {
  if (typeof props.story.newWindow !== 'undefined' && props.story.newWindow === 'true')
    return '_blank'
  else
    return '_self'
})

const storeCodeUrl = computed(() => {
  if (!props.story.url)
    return slug.value
  return isRelativeUrl(props.story.url) ? url(props.story.url) : props.story.url
})
</script>

<template>
  <a v-if="type === 'url' || type === 'external'" :href="storeCodeUrl" :target="target" :rel="rel">
    <slot />
  </a>
  <NuxtLink v-else-if="slug" :to="$url(slug)">
    <slot />
  </NuxtLink>
  <a v-else>
    <slot />
  </a>
</template>
